import { ColumnDef, RowSelectionState } from "@tanstack/react-table";

import { ClientDataTable } from ".";

interface IProps<TData> {
  title: string;
  data: TData[];
  columns: ColumnDef<TData>[];
  isLoading: boolean;

  tablePrefixComponent?: React.FC;
  onRowClick?: (row: TData) => void;
  backBtn?: boolean;
  clientTable?: boolean;
  actions?: React.ReactNode;
  rowSelection?: RowSelectionState;
  setRowSelection?: React.Dispatch<React.SetStateAction<RowSelectionState>>;
}

const ClientTableForData = <TData,>({
  data,
  columns,
  isLoading,
  title,
  backBtn,
  actions,
  rowSelection,
  setRowSelection,
  ...props
}: IProps<TData>) => {
  return (
    <ClientDataTable
      rowSelection={rowSelection}
      setRowSelection={setRowSelection}
      onRowClick={props.onRowClick}
      toolbar={{ title, actions, backBtn }}
      tablePrefixComponent={props.tablePrefixComponent}
      data={data}
      columns={columns}
      isLoading={isLoading}
    />
  );
};

export default ClientTableForData;
